export const Logger = Symbol.for('Logger');

/**
 * Represents a logger that provides logging functionality.
 */
export interface Logger {
    /**
     * Logs the provided arguments.
     * @param args The arguments to be logged.
     */
    log(...args: any[]): void;

    /**
     * Logs a warning with the provided arguments.
     * @param args The arguments to be logged as a warning.
     */
    warn(...args: any[]): void;

    /**
     * Logs an error with the provided arguments.
     * @param args The arguments to be logged as an error.
     */
    error(...args: any[]): void;

    /**
     * Logs an informational message with the provided arguments.
     * @param args The arguments to be logged as an informational message.
     */
    info(...args: any[]): void;
}
